import React from "react";
import "./BottomCard.scss";
export default function BottomCard(props) {
  console.log("props", props);
  return (
    <div className="cardBase">
      <div className="cardContent">
        <div className="cardRightGrid">
          <div className="textBase">
            <p className="cardTitleTxtS1">{props.title}</p>
            <p className="cardSubTxt">{props.txt1}</p>
            <p className="cardSubTxt">{props.txt2}</p>
          </div>
        </div>
        <div className="cardLeftGrid2">
          <div className="imgBase">
            <img src={props.cardImg} alt="cardImg" className="cardImg" />
          </div>
        </div>
      </div>
    </div>
  );
}
